var _style, _defs, _path, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 62",
    style: {
      enableBackground: "new 0 0 54 62"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000160884500155014805590000000209230300880245676_);}\n\t.st1{fill:none;stroke:#ffffff;stroke-width:8;stroke-miterlimit:50;}\n\t.st2{fill:none;stroke:#ffffff;stroke-width:4;stroke-miterlimit:50;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102 -7522)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 102,
    y: 7548,
    width: 54,
    height: 36
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092425240334484840900000009756528507313544341_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092425240334484840900000009756528507313544341_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rbima",
    className: "st1",
    d: "M102,7584v-36h54v36H102z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#ffffff",
      strokeMiterlimit: 10
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rbimc",
    className: "st2",
    d: "M104.1,7550.2l25,18.8l25-18.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rbimd_00000000937267315600502350000008018048063261124518_",
    className: "st2",
    d: "M129,7522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rbimd_00000121249947392556016730000007510274209937521049_",
    className: "st2",
    d: "M129,7532.6"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rbime_00000091700767306638983820000013513871561039431058_",
    className: "st2",
    d: "M107,7526"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rbime_00000018214409635929748930000004478797136013773980_",
    className: "st2",
    d: "M112.1,7535.3"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rbimf_00000109713131464476505820000003616030041275441570_",
    className: "st2",
    d: "M151.1,7526"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rbimf_00000141418096529867522730000017569985403099423106_",
    className: "st2",
    d: "M146,7535.3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c9a906deed5703268329f8e94c214e76.svg";
export { ForwardRef as ReactComponent };